
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { TokenService } from "@/providers/tokens/tokens.service";
import { LocalStorageKeys } from "@/shared/enums/local-storage-keys.enum";

import { type IUser } from "../../api/users/users.interface";

import initialState from "./state";

export const slice = createSlice({
  initialState,
  name: "user",
  reducers: {
    logout: () => {
      TokenService.clearTokens();
      if (typeof window !== "undefined") {
        localStorage.removeItem(LocalStorageKeys.ViewState);
      }
      return initialState;
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.profile = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  logout,
  setUser,
} = slice.actions;
